import { render, staticRenderFns } from "./MostrarCalculos.vue?vue&type=template&id=4956da14&scoped=true&"
import script from "./MostrarCalculos.vue?vue&type=script&lang=js&"
export * from "./MostrarCalculos.vue?vue&type=script&lang=js&"
import style0 from "./MostrarCalculos.vue?vue&type=style&index=0&id=4956da14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4956da14",
  null
  
)

export default component.exports